import { Component } from '@angular/core';
import { select } from '@angular-redux3/store';
import { Observable } from 'rxjs';
import { isAzam } from '@ps20-frontend/shop-integration-redux';

import { Role } from '@ps20/bff-models';
import { AsyncPipe } from '@angular/common';
import { IAppState } from '../../store/localStore';
import { NdbxDesignComponent } from './ndbx-design/ndbx-design.component';
import { ExpertModeDesignComponent } from './expert-mode-design/expert-mode-design.component';

export const selectRole = (state: IAppState): Role => state.transientState.role;

@Component({
  selector: 'ps20-shop-design-container',
  templateUrl: './design-container.component.html',
  imports: [NdbxDesignComponent, ExpertModeDesignComponent, AsyncPipe],
})
export class DesignContainerComponent {
  @select(selectRole) $role: Observable<Role>;

  enableExpertStyles(role: Role): boolean {
    return role === Role.VERTRETER || role === Role.SPS || isAzam(role);
  }

  enableNDBXStyles(role: Role): boolean {
    return role === Role.ENDKUNDE;
  }
}
